import { useCmsPage } from "@/hooks/useCms";
import LoadingScreen from "@/components/LoadingScreen";
import SoftwareHomePage from "@/components/cms/SoftwareHomePage";

export default function HomePage() {
  const { page, loading } = useCmsPage("home");

  if (loading) return <LoadingScreen />;
  if (!page) return null;

  return <SoftwareHomePage page={page} />;
}